module.exports = __webpack_public_path__ + "static/media/heart-solid-red.7dbe9401.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/heart-solid-red.svg
// module id = 208
// module chunks = 0